// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"1c9a3b5f","315":"4b570699","370":"f88b762b","393":"c120517f","538":"03464859","654":"6752e008","787":"fe97c3d3"}[chunkId] + ".chunk.js";
};